
export const NotFound = () => {
    return (
        <div className="flex items-center justify-center h-full flex-col">
            <p className="font-pixel-text text-sm text-center mb-3">There's nothing here</p>
            <p className="font-pixel-text text-sm text-center mb-8">¯\_(ツ)_/¯</p>
        </div>
    )
}